import { render, staticRenderFns } from "./orderSet.vue?vue&type=template&id=28b4e1ff&"
import script from "./orderSet.vue?vue&type=script&lang=js&"
export * from "./orderSet.vue?vue&type=script&lang=js&"
import style0 from "./orderSet.vue?vue&type=style&index=0&id=28b4e1ff&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports